import { Injectable, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of, interval, Subscription } from 'rxjs';
import { devAPI, prodAPI } from '../../../env';

export interface StreamEvent {
  title: string;
  category_name: string;
  category_icon: string;
  overlay_icon: string;
  datetime: string;
}

interface ApiResponse {
  stream_events: StreamEvent[];
}

@Injectable({
  providedIn: 'root'
})
export class StreamScheduleService implements OnDestroy {
  private apiUrl = `${prodAPI}/api/stream-events`;
  private eventsSignal = signal<StreamEvent[]>([]);
  private pollingSubscription?: Subscription;
  private readonly POLLING_INTERVAL = 3600000; // 1 час

  constructor(private http: HttpClient) {
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  getEvents() {
    return this.eventsSignal.asReadonly();
  }

  fetchEvents(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.apiUrl).pipe(
      catchError(err => {
        console.error('Failed to fetch events:', err);
        return of({ stream_events: [] });
      })
    );
  }

  loadEvents(): void {
    this.fetchEvents().subscribe({
      next: (response) => {
        this.eventsSignal.set(response.stream_events || []);
      },
      error: (err) => {
        console.error('Failed to load events:', err);
        this.eventsSignal.set([]);
      }
    });
  }

  private startPolling(): void {
    this.loadEvents();
    
    this.pollingSubscription = interval(this.POLLING_INTERVAL).subscribe(() => {
      this.loadEvents();
    });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }
}